import React, { useState, useContext, useEffect, useRef } from 'react';
import { TableContext } from '../context';
import axios from 'axios';
import '../App.css';
import {
    Dialog,
    DialogContent,
    IconButton,
    Button,
    Checkbox,
    FormControlLabel,
    FormGroup,
    CircularProgress
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const SubscribeDialog = () => {
    const { subscribeOpen, setSubscribeOpen, search, setActiveTab, graphData, getSubscriptions, subscriptions,getToken } = useContext(TableContext);
    const [selectedApps, setSelectedApps] = useState([]);
    const [dialogLoading, setDialogLoading] = useState(false);
    const [subscribed, setSubscribed] = useState(false);
    const [subscriptionFailed, setSubscriptionFailed] = useState(false);
    const [processedApps, setProcessedApps] = useState([]);
    const [unsubscribedApps, setUnsubscribedApps] = useState([]);

    useEffect(() => {
      const fetchAppNames = async (appId) => {
          try {
              const response = await axios.post(
                  `${process.env.REACT_APP_BACKEND_URI}/api/change_data/getAppNameFromAppId`, 
                  { app_id: appId },
                  {
                      headers: {
                          Authorization: "Bearer " + localStorage.getItem("jwt_token"),
                          'Content-Type': 'application/json'
                      }
                  }
              );
              
              if (response.data.status === 200) {
                  return response.data.data;
              } else {
                  console.error('Failed to fetch app names for App ID:', appId);
                  return [];
              }
          } catch (error) {
              console.error('Error fetching app names for App ID:', appId, error);
              return [];
          }
      };

      const processSearch = async () => {
        const apps = search.split(',').map(app => app.trim()).filter(app => app);
        const processedAppsSet = new Set();

        for (const app of apps) {
            if (/^[Aa]\d{2,}$/.test(app)) {
                const appNames = await fetchAppNames(app);
                appNames.forEach((appName) => processedAppsSet.add(appName));
            } else {
              processedAppsSet.add(app);
            }
        }

        const processedAppsList = Array.from(processedAppsSet);
        setProcessedApps(processedAppsList);

        // Filter out apps that user is already subscribed to
        const filteredApps = processedAppsList.filter(app =>
            !subscriptions.includes(app)
        );
        setUnsubscribedApps(filteredApps);
        setSelectedApps(filteredApps);
        setSubscribed(false);
        setSubscriptionFailed(false);
      };

    processSearch();
  }, [search, subscriptions]);

    const handleDialogClose = () => {
        setSubscribeOpen(false); // Closes the popup
    };

    const handleCheckboxChange = (app) => {
      setSelectedApps((prevSelectedApps) =>
          prevSelectedApps.includes(app)
              ? prevSelectedApps.filter((selectedApp) => selectedApp !== app)
              : [...prevSelectedApps, app]
      );
    };

    const handleConfirmClick = async () => {
      setDialogLoading(true);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URI}/api/subscription/subscribe`, 
          { 
            user_name: graphData?.displayName,
            user_email: graphData?.mail,
            app_name: selectedApps,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("jwt_token"),
            }
          }
        );
        
        console.log("Selected Apps for subscription:", selectedApps);
        if (response.data.status === 200) {
            getSubscriptions();
            setSubscribed(true);
        } else {
            console.error('Subscription failed');
            setSubscriptionFailed(true);
        }
      } catch (error) {
        console.error(error);
        setSubscriptionFailed(true);
      } finally {
        setDialogLoading(false);
      }
    };

    return(
        <Dialog 
          open={subscribeOpen} 
          onClose={handleDialogClose} 
          maxWidth="sm" 
          fullWidth
          PaperProps={{
            style: {
              marginTop: '-40vh'
            }
          }}
        >
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleDialogClose}
              aria-label="close"
              style={{ position: "absolute", right: 8, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
            <DialogContent>
              {dialogLoading ? (
                <div style={{ textAlign: 'center', margin: '20px' }}>
                  <CircularProgress />
                  <p>Subscribing to Application(s)...</p>
                </div>
              ) : subscribed ? (
                <div>
                  <p>You have successfully Subscribed to the following Application(s) with <br />Default settings:</p>
                  <div style={{ maxHeight: "200px", overflowY: "auto", marginTop: '10px', marginBottom: '10px' }}>
                    <ul  style={{ paddingLeft: '20px', marginTop: '0px' }}>
                      {selectedApps.map((app) => (
                        <li key={app}>{app}</li>
                      ))}
                    </ul>
                  </div>
                  <p><i>If you wish to customize your Subscription, go to Notification Settings from the Bell Icon or <a href="/Subscriptions?tab=NotificationSettings">click here</a></i></p>
                </div>
              ) : subscriptionFailed ? (
                <div style={{ textAlign: 'center', margin: '20px' }}>
                  <p>Subscription failed. Please try again later.</p>
                </div>
              ):(
                <>
                  {unsubscribedApps.length > 0 ? (
                    <div>
                      <p><strong>Do you wish to Subscribe to the following Application(s):</strong></p>
                      <div style={{ maxHeight: "200px", overflowY: "auto", marginTop: '10px' }}>
                        <FormGroup>
                            {unsubscribedApps.map((app) => (
                                <FormControlLabel
                                    key={app.trim()}
                                    control={
                                        <Checkbox
                                            checked={selectedApps.includes(app)}
                                            onChange={() => handleCheckboxChange(app)}
                                            sx={{
                                                color: '#141414',
                                                '&.Mui-checked': {
                                                    color: '#141414',
                                                },
                                            }}
                                        />
                                    }
                                    label={app}
                                />
                            ))}
                        </FormGroup>
                      </div>
                      <button
                        onClick={handleConfirmClick} 
                        className="animated-search-button"
                        disabled={selectedApps.length === 0}
                        style={{ marginTop: '16px', marginLeft: '470px' }}
                      >
                        Confirm
                      </button>
                    </div>
                  ) : processedApps.length > 0 ? (
                    <div style={{ textAlign: 'center', margin: '20px' }}>
                      <p>You are already subscribed to all the searched applications.</p>
                    </div>
                  ) : (
                    <p>No apps searched.</p>
                  )}
                </>
              )}
            </DialogContent>
        </Dialog>
    );
}

export default SubscribeDialog;